/**
 * Knowt: Quizlet Import, AI Notes & Flashcards
 *
 * One WAR entry is broad (`<all_urls>`, no `use_dynamic_url`) and holds the bundled
 * BwModelica web fonts — stably named by family/weight, not build-hashed, so a fixed
 * fetch stays valid across releases. (A second WAR group holds build-hashed assets
 * scoped to study sites; those we avoid.)
 *
 * Manifest verified against version 4.4.3.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'akegecpdcdbkjioddaingaedacjgfjhm';

export const knowt: ExtensionDefinition = {
  id: ID,
  name: 'Knowt: Quizlet Import, AI Notes & Flashcards',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Bundled BwModelica fonts are exposed to every origin at a stable path; the rest of ' +
    'its WAR is build-hashed and site-scoped. The font fetch is conclusive.',
  signals: [
    {
      id: 'war-bwmodelica-medium',
      kind: 'web-accessible-resource',
      description:
        'Fetch fonts/bw-modelica/BwModelica-SS01-Medium.woff2 — a stably-named bundled ' +
        'font exposed to every origin.',
      weight: 1,
      run: () => probeFetch(ID, 'fonts/bw-modelica/BwModelica-SS01-Medium.woff2'),
    },
    {
      id: 'war-bwmodelica-bold',
      kind: 'web-accessible-resource',
      description: 'Fetch the Bold weight of the same font — a second stable path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'fonts/bw-modelica/BwModelica-SS01-Bold.woff2'),
    },
  ],
};
